<div class="header_hero-bg"></div>
<div class="mega-trade-container container-fluid">
  <div class="mega_body-content">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header" id="review-pool-changes-header">
            Review Pool Changes
          </div>
        </div>
      </div>

      <ng-container *ngIf="showCommitErrorMessage">
        <div class="row error-banner-container">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <div class="status-icon float-end">
              <img alt="" src="assets/images/icon_error_white.svg" />
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-9 col-lg-9">
            <p class="file-format-text">{{ errorMsg }}</p>
          </div>
          <div class="col-1 col-sm-1 col-md-2 col-lg-2">
            <div class="exit-button float-end" (click)="closeCommitErrorBanner()">
              <img src="assets/images/x_white.svg" />
            </div>
          </div>
        </div>
      </ng-container>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
            <div id="pool-type-label" class="text-size">Pool Type</div>
          </div>
          <div
            (click)="goBack()"
            class="col-12 col-sm-12 col-md-4 col-lg-4 back-and-edit visible-md-4 visible-lg-4 pr-0 float-end"
          >
            <i class="fa fa-arrow-circle-o-left go-back-icon" id="edit-collateral"></i>Edit
            Collateral
          </div>
          <div
            (click)="goBack()"
            class="col-12 col-sm-12 col-md-4 col-lg-4 back-and-edit-screen hidden-md hidden-lg float-end"
          >
            <i class="fa fa-arrow-circle-o-left go-back-icon" id="edit-collateral-sm"></i>Edit
            Collateral
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <div class="col-12 col-sm-12 col-md-3 col-lg-3">
            <div class="fw-bold-and-size" id="pool-type-value">
              <ng-container *ngIf="calcFeeRes.megaType === 'SFFIXMEGA'">
                Single Family Fixed Rate
              </ng-container>
              <ng-container *ngIf="calcFeeRes.megaType === 'SFARMMEGA'">
                Single Family ARM
              </ng-container>
              <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                Multi Family Fixed Rate
              </ng-container>
              <ng-container *ngIf="calcFeeRes.megaType === 'MFARMMEGA'">
                Multi Family ARM
              </ng-container>
            </div>
          </div>
          <div
            (click)="onUploadNewCollateral()"
            class="col-12 col-sm-12 col-md-9 col-lg-9 visible-md-9 pr-0 back-and-edit float-end"
          >
            <i class="fa fa-arrow-circle-o-left go-back-icon" id="upload-new-collateral"></i>Upload
            New Collateral
          </div>
          <!-- <div (click)="onUploadNewCollateral()"
                class="visible-xs-12 hidden-md hidden-lg col-12 back-and-edit-screen float-end">
              <i class="fa fa-arrow-circle-o-left go-back-icon" id="upload-new-collateral-sm"></i>Upload New Collateral
            </div> -->
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-10">
          <div class="fm-cdx-table">
            <table class="fm-cdx-table__static">
              <thead id="review-page-single-pool-head">
                <tr class="th_row">
                  <th class="th_column">POOL #</th>
                  <th class="th_column width-25">CUSIP</th>
                  <th class="th_column width-25">PREFIX</th>
                  <ng-container *ngIf="calcFeeRes.megaType === 'SFFIXMEGA'">
                    <th class="th_column th_column--is-numeric">COUPON</th>
                  </ng-container>
                  <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                    <th class="th_column th_column--is-numeric">HIGH COUPON</th>
                  </ng-container>
                  <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                    <th class="th_column th_column--is-numeric">LOW COUPON</th>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      calcFeeRes.megaType === 'SFARMMEGA' || calcFeeRes.megaType === 'MFARMMEGA'
                    "
                  >
                    <th class="th_column">SUBTYPE</th>
                  </ng-container>
                  <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                  <th class="th_column pl-85">SETTLEMENT</th>
                  <th class="th_column th_column--is-numeric">FEE</th>
                </tr>
              </thead>
              <tbody id="review-page-single-pool-body">
                <tr class="td_row commit-mega-table-header">
                  <td class="td_cell">
                    <span class="commit-to-recive-color" id="megaNumber">Commit to Receive</span>
                  </td>
                  <td class="td_cell">
                    <span class="commit-to-recive-color" id="cusip">Commit to Receive</span>
                  </td>
                  <td class="td_cell">
                    <span id="prefix">{{
                      calcFeeRes?.prefixCode ? calcFeeRes?.prefixCode : ''
                    }}</span>
                  </td>
                  <ng-container *ngIf="calcFeeRes.megaType === 'SFFIXMEGA'">
                    <td class="td_cell td_cell--is-numeric">
                      <span id="sfFixedCoupon">{{
                        calcFeeRes?.sfFixedCoupon | number: '1.3-3'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                    <td class="td_cell td_cell--is-numeric">
                      <span id="mfHighCoupon">{{
                        calcFeeRes?.mfHighCoupon | number: '1.3-3'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                    <td class="td_cell td_cell--is-numeric">
                      <span id="mfLowCoupon">{{ calcFeeRes?.mfLowCoupon | number: '1.3-3' }}</span>
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      calcFeeRes.megaType === 'SFARMMEGA' || calcFeeRes.megaType === 'MFARMMEGA'
                    "
                  >
                    <td class="td_cell">
                      <span id="sfARMSubType">{{ calcFeeRes?.sfARMSubType }}</span>
                    </td>
                  </ng-container>
                  <td class="td_cell td_cell--is-numeric">
                    <span id="tradeAmount">{{
                      calcFeeRes?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                    }}</span>
                  </td>
                  <ng-container *ngIf="!showEarlyCloseLegend">
                    <td class="td_cell">
                      <span id="tradeSettlementDate">{{
                        calcFeeRes?.tradeSettlementDate | date: 'MM/dd/yyyy'
                      }}</span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="showEarlyCloseLegend">
                    <td class="td_cell">
                      <span id="tradeSettlementDate-earlyClose"
                        >{{ calcFeeRes?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}<i class="fa fa-asterisk legend-icon pl-3"></i
                      ></span>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="calcFeeRes?.feeDollars !== null">
                    <td class="td_cell td_cell--is-numeric">
                      <ng-container *ngIf="needsDisclaimer(calcFeeRes); else noDisclaimer">
                        <span class="fw-bold fee-warning-red" id="newFeeDollars">
                          {{ calcFeeRes?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                        </span>
                      </ng-container>
                      <ng-template #noDisclaimer>
                        <span class="fw-bold" id="newFeeDollars"
                          >{{ calcFeeRes?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                        </span>
                      </ng-template>
                    </td>
                  </ng-container>
                  <ng-container *ngIf="calcFeeRes?.feeTicks !== null">
                    <td class="td_cell td_cell--is-numeric">
                      <ng-container *ngIf="needsDisclaimer(calcFeeRes); else noTickDisclaimer">
                        <span class="fw-bold fee-warning-red" id="newFeeTicks"
                          >{{ calcFeeRes?.feeTicks | number: '1.3-3' }}/32*
                        </span>
                      </ng-container>
                      <ng-template #noTickDisclaimer>
                        <span class="fw-bold" id="newFeeTicks"
                          >{{ calcFeeRes?.feeTicks | number: '1.3-3' }}/32
                        </span>
                      </ng-template>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-10">
          <p class="fee-warning-red">{{ disclaimerMessage }}</p>
        </div>
      </div>
      <div class="row">
        <section
          *ngIf="megaPricingUpdateList.length > 0"
          class="col-12 col-sm-12 col-md-12 col-lg-12 mega-pricing-updates-section mt-25 pl-0 pr-0"
        >
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 mb-8">
            <div class="col-12 col-sm-12 col-md-9 col-lg-9">
              <span>
                <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
                <span id="pricing-summary-info-text"
                  >Upon commiting the above, pricing for the following committed pools will be
                  affected</span
                >
              </span>
            </div>
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 visible-md-3 pr-0">
              <span class="float-end" id="pricing-summary-count"
                >Total Pools: {{ megaPricingUpdateList.length }}</span
              >
            </div>
            <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12">
              <span class="col-12 pl-0" id="pricing-summary-count-sm">Total Pools: {{ megaPricingUpdateList.length }}</span>
            </div> -->
          </div>
          <div
            *ngIf="megaPricingUpdateList !== null"
            class="col-12 col-sm-12 col-md-12 col-lg-12 mega-pricing-update-table px-0"
          >
            <div class="fm-cdx-table">
              <table class="fm-cdx-table__static">
                <thead id="pricing-summary-head">
                  <tr class="th_row">
                    <th class="th_column">POOL #</th>
                    <th class="th_column width-25">CUSIP</th>
                    <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                    <th class="th_column pl-85">SETTLEMENT</th>
                    <th class="th_column th_column--is-numeric">PREVIOUS FEE</th>
                    <th class="th_column th_column--is-numeric">NEW FEE</th>
                  </tr>
                </thead>
                <tbody id="pricing-summary-body">
                  <tr
                    *ngFor="let megaPricing of megaPricingUpdateList; trackBy: trackByIdentity"
                    class="td_row commit-mega-pricing-update-table-header"
                  >
                    <td class="td_cell">
                      <span class="pool-item-mega-number">{{ megaPricing?.poolNumber }}</span>
                    </td>
                    <td class="td_cell">
                      <span class="pool-item-cusip">{{ megaPricing?.cusip }}</span>
                    </td>
                    <td class="td_cell td_cell--is-numeric">
                      <span class="pool-item-trade-amount">{{
                        megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                      }}</span>
                    </td>
                    <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85">
                        <span id="pool-item-settlement-date">{{
                          megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                        }}</span>
                      </td>
                    </ng-container>
                    <ng-container *ngIf="megaPricing.earlyCloseFlag">
                      <td class="td_cell pl-85">
                        <span id="pool-item-settlement-date-earlyClose"
                          >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                          }}<i class="fa fa-asterisk legend-icon pl-3"></i
                        ></span>
                      </td>
                    </ng-container>
                    <td class="td_cell td_cell--is-numeric">
                      <ng-container *ngIf="megaPricing?.prevFeeDollars !== null">
                        <span class="pool-item-trade-amount fw-bold">{{
                          megaPricing?.prevFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                        }}</span>
                      </ng-container>
                      <ng-container *ngIf="megaPricing?.prevFeeTicks !== null">
                        <span class="pool-item-trade-amount fw-bold"
                          >{{ megaPricing?.prevFeeTicks | number: '1.3-3' }}/32</span
                        >
                      </ng-container>
                    </td>
                    <td class="td_cell td_cell--is-numeric">
                      <ng-container *ngIf="megaPricing?.newFeeDollars !== null">
                        <span class="pool-item-trade-amount fw-bold">{{
                          megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                        }}</span>
                      </ng-container>
                      <ng-container *ngIf="megaPricing?.newFeeTicks !== null">
                        <span class="pool-item-trade-amount fw-bold"
                          >{{ megaPricing?.newFeeTicks | number: '1.3-3' }}/32
                        </span>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-8 col-lg-8 mt-25 pool-allocation-notice-bgcolor">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <span>
              <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
              <span class="fw-bold-and-size" id="pool-allocation-notice-label"
                >Pool Allocation Notice</span
              >
            </span>
          </div>
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 text-size"
            id="pool-allocation-label-info"
          >
            By booking this Mega/Supers, the submitted collateral
            <span class="fw-bold">will automatically be allocated to Fannie Mae.</span><br />
            Please ensure you wish to have this collateral allocated prior to booking this
            Mega/Supers.
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-10" *ngIf="showFeature">
            <a class="review-collateral-list-link" id="review-collateral-list-linkbutton"
              >Review collateral list(xls)</a
            >
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-25 pl-0 pr-0">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <label class="terms-conditions-title" id="terms-conditions-label"
              >Terms & Conditions</label
            >
          </div>
          <div class="col-8 col-sm-8 col-md-8 col-lg-8">
            <p>
              By entering into a Supers transaction where the settlement is scheduled less than 48
              hours after the transaction has been booked, an investor is thereby agreeing to waive
              application of the 48-Hour Rule, as provided in Section B-2 of Chapter 7 of the
              Uniform Practices Manual, as published by the Securities Industry and Financial
              Markets Association.
            </p>
            <p id="terms-conditions-info">
              The use of this application is subject to the terms of your existing contractual
              arrangements with Fannie Mae including, without limitation, the Software Subscription
              Agreement or Technology License Agreement and any applicable contracts relating to the
              acquisition and distribution of Megas securities or Supers securities (collectively,
              the “Securities Contracts”). By clicking the “Commit” button below, you are entering
              into a legally-binding commitment under the applicable Securities Contracts to acquire
              Megas securities or Supers securities from Fannie Mae, as applicable, pursuant to the
              terms and conditions set forth in this application and any application-related
              confirmations.
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="commit-cancel">
            <button
              class="button fm-primary-button"
              id="commit-allocate-button"
              (click)="commitMega()"
              [disabled]="isCommitButtonClicked"
            >
              Commit & Allocate
            </button>
            <button
              class="button fm-tertiary-button"
              id="goback-edit-button"
              (click)="onGoBackAndEdit()"
            >
              Go Back & Edit
            </button>
            <button
              class="button fm-tertiary-button"
              id="cancel-startover-button"
              (click)="onCancelStartOverClick()"
            >
              Cancel & Start Over
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="displayCancelCollateralPopup">
  <div class="replace-collateral-model-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="row">
        <div class="col-sm-6 col-6 col-md-6 col-lg-6">
          <h2 class="cancel-popup-title" id="cancel-popup-title">
            {{ cancelPopUpTitle }}
          </h2>
        </div>
        <div class="col-sm-6 col-6 col-md-6 col-lg-6 mt-36">
          <button
            type="button"
            class="close float-end"
            aria-label="Close"
            (click)="hideCancelCollateralPopup()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-popup">
          <div class="line-break"></div>
        </div>
      </div>
      <div class="panel-body">
        <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
          <div class="col-1 col-sm-1 col-md-1 col-lg-1">
            <i class="fa fa-exclamation-triangle warning-exclamation-icon" id="warning-icon"></i>
          </div>
          <ng-container *ngIf="uploadNewCollateralLinkClicked">
            <div class="col-11 col-sm-11 col-md-11 col-lg-11 pl-0">
              <p id="cancel-upload-info-text-1">{{ cancelUploadCollateralInfoText }}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="cancelAndStartOverButtonClicked">
            <div class="col-11 col-sm-11 col-md-11 col-lg-11 pl-0 cancel-start-over-text">
              <p id="cancel-upload-info-text-2">{{ cancelUploadCollateralInfoText }}</p>
            </div>
          </ng-container>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 mt-20 ml-20">
          <p id="do-you-proceed-text">Do you wish to proceed?</p>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0 footer-block pr-20">
        <div class="float-end pl-0 pr-0">
          <button
            class="button fm-tertiary-button"
            (click)="hideCancelCollateralPopup()"
            id="cancel-upload-button"
          >
            Cancel
          </button>
          <button
            class="button fm-primary-button"
            *ngIf="uploadNewCollateralLinkClicked"
            (click)="onReplaceNewCollateralFile()"
            id="yes-replace-button"
          >
            {{ cancelButtonLabel }}
          </button>
          <button
            class="button fm-primary-button"
            *ngIf="cancelAndStartOverButtonClicked"
            (click)="onYesAndStartOver()"
            id="yes-start-over-button"
          >
            {{ cancelButtonLabel }}
          </button>
        </div>
      </div>
      <!-- <div class="visible-xs-12 hidden-md hidden-lg  col-12 col-sm-12 pl-0 footer-block-sm-screen pr-20">
            <div class="float-end pl-0 pr-0">
                <button class="button fm-primary-button" *ngIf="uploadNewCollateralLinkClicked"
                (click)="onReplaceNewCollateralFile()"
                id="yes-replace-button-sm">{{cancelButtonLabel}}
        </button>
        <button class="button fm-primary-button" *ngIf="cancelAndStartOverButtonClicked"
                (click)="onYesAndStartOver()"
                id="yes-start-over-button-sm">{{cancelButtonLabel}}
        </button>
            </div>
        </div> -->
    </div>
  </div>
</ng-container>
